










































































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Fournisseur, Contact, Token} from '@/models';

import storeFournisseur from '@/stores/modules/fournisseur';
import storeToken from "@/stores/modules/token";
import storeContact from "@/stores/modules/contact";

import CrudAddressShow from '@/components/Crud/Address/Show.vue';
import CrudContactList from '@/components/Crud/Contact/List.vue';
import CrudFournisseurEditDialogLight from '@/components/Crud/Fournisseur/EditDialogLight.vue';
import CrudFournisseurAdressesEditDialog from '@/components/Crud/Fournisseur/EditAdressesDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudContactEditDialog from '@/components/Crud/Contact/EditDialog.vue';

@Component({
	components: {
		CrudAddressShow,
		CrudContactList,
		CrudFournisseurEditDialogLight,
		CrudFournisseurAdressesEditDialog,
		CrudDeleteDialog,
		CrudContactEditDialog,
	}
})
export default class CrudFournisseurShow extends AbstractShowVue<Fournisseur> {

	private imgPath: string = "";

	private editFournisseur: Fournisseur = null;
	private editFournisseurAdresses: Fournisseur = null;

	private editContact: Contact = null;
	private deletedContact: Contact = null;

	@Stored(() => storeToken)
	private token: Token;

	private storeContact = storeContact;

	public constructor() {
		super(storeFournisseur);
	}

	public async mounted(): Promise<void> {
		storeContact.state.filters.clear();
		await super.mounted();

	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'fournisseur-show') {
				this.$route.meta.title = 'Détails  d\'un fournisseur';
			}
		}

	}

	@Emit()
	private onCreateContact(): void {
		this.editContact = new Contact();
		this.editContact.fournisseur = this.item;
	}

	private async refreshContacts(): Promise<void> {
		await Promise.all([
			storeContact.dispatch('getC', { filters: true }),
			this.refresh(this.value),
		]);
	}

}
